<section class="supplier-responses">
  <header class="supplier-responses-header">
    <strong class="supplier-responses-title">Fornecedores</strong>
    <span
      class="supplier-responses-summary"
      [class.supplier-responses-summary--complete]="data.inQuotation && allResponded()">
      {{ summaryLabel() }}
    </span>
    @if (data.inQuotation) {
      <div
        class="supplier-responses-progress"
        role="progressbar"
        [attr.aria-valuenow]="progress()"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Respostas recebidas">
        <span
          class="supplier-responses-progress-bar"
          [style.width.%]="progress()"></span>
      </div>
    }
  </header>

  <div class="supplier-responses-body">
    @if (data.inQuotation) {
      @if (pending().length > 0) {
        <h4 class="supplier-responses-group">Aguardando resposta ({{ pending().length }})</h4>
        <ul class="supplier-responses-list">
          @for (supplier of pending(); track supplier.id) {
            <li class="supplier-responses-item supplier-responses-item--pending">
              <mat-icon aria-hidden="true">hourglass_top</mat-icon>
              <span class="supplier-responses-name">{{ supplier.name }}</span>
              @if (supplier.email) {
                <span class="supplier-responses-email">{{ supplier.email }}</span>
              }
            </li>
          }
        </ul>
      }

      @if (responded().length > 0) {
        <h4 class="supplier-responses-group">Responderam ({{ responded().length }})</h4>
        <ul class="supplier-responses-list">
          @for (supplier of responded(); track supplier.id) {
            <li class="supplier-responses-item supplier-responses-item--responded">
              <mat-icon aria-hidden="true">check_circle</mat-icon>
              <span class="supplier-responses-name">{{ supplier.name }}</span>
              @if (supplier.email) {
                <span class="supplier-responses-email">{{ supplier.email }}</span>
              }
            </li>
          }
        </ul>
      }
    } @else {
      <ul class="supplier-responses-list">
        @for (supplier of data.suppliers; track supplier.id) {
          <li class="supplier-responses-item">
            <mat-icon aria-hidden="true">storefront</mat-icon>
            <span class="supplier-responses-name">{{ supplier.name }}</span>
            @if (supplier.email) {
              <span class="supplier-responses-email">{{ supplier.email }}</span>
            }
          </li>
        }
      </ul>
    }
  </div>

  @if (data.hasPendingSuggestedSuppliers) {
    <p class="supplier-responses-note">
      <mat-icon aria-hidden="true">priority_high</mat-icon>
      Há fornecedores sugeridos pela Cotação Inteligente aguardando sua aprovação.
    </p>
  }
</section>
